<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<section class="example-section">
  <mat-progress-bar
      class="example-margin"
      [color]="color"
      [mode]="mode"
      [value]="progresBarValue"
      [bufferValue]="bufferValue">
  </mat-progress-bar>
</section>

<div class="container design-overview-wrapper">
  <form focusInvalidInput class="form" (ngSubmit)="designForm.form.valid && save()" #designForm="ngForm">
  <h2>{{designEditNewCopyMode + ' Design'}}</h2>
  <hr>
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link" routerLink="/home">Home</a>
      </li>
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link"
          routerLink="/design">Design</a>
      </li>
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link">
          {{designEditNewCopyMode + ' Design'}}</a>
      </li>
    </ul>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          1.0
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Design Name <i style="color:red;">*</i></p>
      </div>
    </div>
    <mat-form-field appearance="fill" floatLabel="always">
      <input matInput type="text" [(ngModel)]="design.hvac_dsn_descrpt" (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="hvac_dsn_descrpt"
        class="example-right-align" placeholder="Name of the Design" #hvac_dsn_descrpt = 'ngModel'  required>
    </mat-form-field>
    <mat-error class='loadErrors' *ngIf="designForm.submitted && hvac_dsn_descrpt.errors?.required"> Design Name Is Required
    </mat-error>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex flex-wrap row">
      <div class="d-flex col-md-6 flex-column px-3">
        <div class="d-flex">
          <div class="pe-3">
            <span class="design-overview-wrapper__item__item-number">
              1.1
            </span>
          </div>
          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">Designer Company<i style="color:red;">*</i></p>
          </div>
        </div>
        <mat-form-field appearance="fill" floatLabel="always">
          <input matInput type="text" readonly [(ngModel)]="design.customer_id2" (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="customer_id2" #customer_id2="ngModel" required class="example-right-align"
            placeholder="0">
        </mat-form-field>
        <mat-error class='loadErrors' *ngIf="designForm.submitted && customer_id2.errors?.required">Designer Company Is Required
        </mat-error>
      </div>
      <div class="d-flex col-md-6 flex-column px-3">
        <p class="design-overview-wrapper__item__title">Designer Name<i style="color:red;">*</i></p>
        <mat-form-field appearance="fill" floatLabel="always">
          <input matInput type="text" readonly class="example-right-align" [ngModelOptions]="{standalone: false}" [(ngModel)]="design.contact_id2" (blur)="validateInputs()" #contact_id2="ngModel" required name="contact_id2"
            placeholder="Designer name">
        </mat-form-field>
        <mat-error class='loadErrors' *ngIf="designForm.submitted && contact_id2.errors?.required">Designer Name Is Required
        </mat-error>
      </div>

    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex flex-column">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number tooltip">
            2.1 <div class="right"><h3>9.</h3> <p>Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance.</p></div>
          </span>
        </div><sup class='supTooltip tooltip'>?<div class="right"><h3>9.</h3> <p>Airflow design rates and run-times shall be determined using ASHRAE 62.2-2010 or later. Designers are permitted, but not required, to use published addenda and/or the 2013 or 2016 version of the standard to assess compliance.</p></div>
        </sup>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Ventilation airflow design rate & run-time meet the requirements of ASHRAE 62.2-2010, 2013, or 2016.</p>
        </div>
      </div>
      <mat-radio-group name="ventmeet622" [(ngModel)]="design.ventmeet622" (blur)="validateInputs()" [ngModelOptions]="{standalone: false}"  >
        <mat-radio-button value="Verified" checked="true" class="me-3">Verified</mat-radio-button>
        <mat-radio-button value="Not Verified">Not Verified</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="design-overview-wrapper__item d-flex flex-column">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          2.2
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Ventilation airflow design rate required by 62.2 for a
          continuous system</p>
      </div>
    </div>
    <div class="col-md-6 col-12 d-flex">
    <mat-form-field appearance="fill" floatLabel="always">
      <input matInput type="number" [(ngModel)]="design.venair622" (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="venair622" class="example-right-align"
        placeholder="0">
      <span matSuffix>CFM</span>
    </mat-form-field>
  </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number tooltip">
          3.1 <div class="right"><h3>16.</h3> <p>Select “2013 ASHRAE Fundamentals” if using Chapter 17 of the 2013 ASHRAE Handbook of Fundamentals. Select “Other per AHJ” if the Authority Having Jurisdiction where the home will be certified mandates the use of a load calculation methodology other than Unabridged ACCA Manual J v8 or 2013 ASHRAE Fundamentals.</p></div>
        </span>
      </div><sup class='supTooltip tooltip'>?<div class="right"><h3>16.</h3> <p>Select “2013 ASHRAE Fundamentals” if using Chapter 17 of the 2013 ASHRAE Handbook of Fundamentals. Select “Other per AHJ” if the Authority Having Jurisdiction where the home will be certified mandates the use of a load calculation methodology other than Unabridged ACCA Manual J v8 or 2013 ASHRAE Fundamentals.</p></div>
      </sup>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Room by room loads calculated using:</p>
      </div>
    </div>
    <mat-radio-group name="heatlossmtd" [(ngModel)]="design.heatlossmtd" (change)="validateInputs()" [ngModelOptions]="{standalone: false}">
      <mat-radio-button value="Unabridged ACCA Manual J v8" checked="true" class="me-3">Unabridged ACCA Manual J v8
      </mat-radio-button>
      <mat-radio-button value="2013 ASHRAE Fundamentals" class="me-3">2013 ASHRAE Fundamentals</mat-radio-button>
      <mat-radio-button value="Other per AHJ">Other per AHJ</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.2
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Indoor design temperatures used in loads are 70F for heating and 75F for cooling.
        </p>
      </div>
    </div>
    <mat-radio-group name="indoortemp" [(ngModel)]="design.indoortemp" (change)="validateInputs()" [ngModelOptions]="{standalone: false}">
      <mat-radio-button value="Verified" checked="true" class="me-3">Verified</mat-radio-button>
      <mat-radio-button value="Not Verified" class="me-3">Not Verified</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number tooltip">
          3.3 <div class="right" style="min-width: 600px;"><h3>17.</h3> <p>Visit energystar.gov/hvacdesigntemps for the maximum cooling season design temperature and minimum heating season design temperature permitted for ENERGY STAR Single-Family New Homes. For “County & State, or US Territory, selected”, select the County and State or US Territory (i.e., Guam, Northern Mariana Islands, Puerto Rico, or US Virgin Islands), where the home is to be certified. The same design report is permitted to be used in other counties, as long as the design temperature limits in those other counties meet or exceed the cooling and heating season temperature limits for the county selected. For example, if Frederick County, VA, is used for the load calculations, with a 1% cooling temperature limit of 93 °F, then the same report could be used in Fairfax County (which has a higher limit of 94 °F) but not in Albemarle County (which has a lower limit of 92 °F). If a jurisdiction-specified design temperature is used that exceeds the limit in the Design Temperature Limit Reference Guide, designers must submit a Design Temperature Exception Request available at energystar.gov/hvacdesigntemps.</p>
          </div>
        </span>
      </div><sup class='supTooltip tooltip'>?<div class="right" style="min-width: 600px;"><h3>17.</h3> <p>Visit energystar.gov/hvacdesigntemps for the maximum cooling season design temperature and minimum heating season design temperature permitted for ENERGY STAR Single-Family New Homes. For “County & State, or US Territory, selected”, select the County and State or US Territory (i.e., Guam, Northern Mariana Islands, Puerto Rico, or US Virgin Islands), where the home is to be certified. The same design report is permitted to be used in other counties, as long as the design temperature limits in those other counties meet or exceed the cooling and heating season temperature limits for the county selected. For example, if Frederick County, VA, is used for the load calculations, with a 1% cooling temperature limit of 93 °F, then the same report could be used in Fairfax County (which has a higher limit of 94 °F) but not in Albemarle County (which has a lower limit of 92 °F). If a jurisdiction-specified design temperature is used that exceeds the limit in the Design Temperature Limit Reference Guide, designers must submit a Design Temperature Exception Request available at energystar.gov/hvacdesigntemps.</p>
      </div></sup>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Outdoor design temperatures used in loads:
        </p>
      </div>
    </div>
    <div class="d-flex flex-wrap row">
      <div class="d-flex col-md-6 flex-column px-3">
        <p class="design-overview-wrapper__item__detail"> <b>County Selected: {{design?.outdoortemplocation}}</b>
        </p>
        <mat-form-field appearance="fill">
          <mat-select placeholder="Select County" [(ngModel)]="selectedSeason" (ngModelChange)="validateInputs()" [ngModelOptions]="{standalone: false}" name="fanspeed"
            (ngModelChange)="changeSeason()">
            <mat-option *ngFor="let season of seasons" [value]="season.temp_id">
              {{season.county}} - {{season.state}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="d-flex col-md-6 flex-column px-3">
        <p class="design-overview-wrapper__item__detail">Cooling Season:
        </p>
        <mat-form-field appearance="fill" floatLabel="always">
          <input matInput type="number" maxlength="5" [(ngModel)]="design.outdoor1_" name="cs" (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" readonly
            class="example-right-align" placeholder="0" >
          <span matSuffix>F°</span>
        </mat-form-field>
      </div>

      <div class="d-flex col-md-6 flex-column px-3 ms-auto">
        <p class="design-overview-wrapper__item__detail">Heating Season:
        </p>
        <mat-form-field appearance="fill" floatLabel="always">
          <input matInput type="number" maxlength="5" [ngModelOptions]="{standalone: false}" name="hs" [(ngModel)]="design.outdoor99_" (blur)="validateInputs()" readonly class="example-right-align"
            placeholder="0" >
          <span matSuffix>F°</span>
        </mat-form-field>
      </div>
    </div>

  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number tooltip">
          3.4 <div class="right" style="min-width: 600px;"> <h3>18.</h3>To determine the number of occupants among all HVAC systems in the home, calculate the number of bedrooms, as defined below, and add one. This number of occupants must be within ± 2 of the home to be certified, unless Item 1.5 indicates that the system is a cooling system for temporary occupant loads. A bedroom is defined by ANSI / RESNET / ICC Standard 301-2014 as a room or space 70 sq. ft. or greater size, with egress window and closet, used or intended to be used for sleeping. A “den”, “library”, or “home office” with a closet, egress window, and 70 sq. ft. or greater size or other similar rooms shall count as a bedroom, but living rooms and foyers shall not. An egress window, as defined in 2009 IRC section R310, shall refer to any operable window that provides for a means of escape and access for rescue in the event of an emergency. The egress window definition has been summarized for convenience. The egress window shall:
            <ul>• have a sill height of not more than 44 inches above the floor; AND  </ul>
            <ul>• have a minimum net clear opening of 5.7 sq. ft., height of 24 in., and width of 20 in.; AND </ul>
            <ul>• be operational from the inside of the room without the use of keys, tools or special knowledge.</ul>
             </div>
        </span>
      </div><sup class='supTooltip tooltip'>?<div class="right" style="min-width: 600px;"> <h3>18.</h3>To determine the number of occupants among all HVAC systems in the home, calculate the number of bedrooms, as defined below, and add one. This number of occupants must be within ± 2 of the home to be certified, unless Item 1.5 indicates that the system is a cooling system for temporary occupant loads. A bedroom is defined by ANSI / RESNET / ICC Standard 301-2014 as a room or space 70 sq. ft. or greater size, with egress window and closet, used or intended to be used for sleeping. A “den”, “library”, or “home office” with a closet, egress window, and 70 sq. ft. or greater size or other similar rooms shall count as a bedroom, but living rooms and foyers shall not. An egress window, as defined in 2009 IRC section R310, shall refer to any operable window that provides for a means of escape and access for rescue in the event of an emergency. The egress window definition has been summarized for convenience. The egress window shall:
        <ul>• have a sill height of not more than 44 inches above the floor; AND  </ul>
        <ul>• have a minimum net clear opening of 5.7 sq. ft., height of 24 in., and width of 20 in.; AND </ul>
        <ul>• be operational from the inside of the room without the use of keys, tools or special knowledge.</ul>
         </div></sup>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Number of occupants used in loads:</p>
      </div>
    </div>
    <div class="col-md-6 col-12">
    <mat-form-field appearance="fill" floatLabel="always">
      <input matInput type="number" maxlength="5" [ngModelOptions]="{standalone: false}" [(ngModel)]="design.noocupants" name="occupants" (blur)="validateInputs()" class="example-right-align"
        placeholder="Number of occupants used in loads:">
    </mat-form-field>
  </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number tooltip">
          3.5 <div class="right"><h3>19.</h3> The difference between the Conditioned Floor Area (CFA) used in the design and the actual home to be certified must fall within the tolerance specified in Footnote 2, as verified by a Rater. Be advised, the Rater will calculate CFA using the definition in ANSI / RESNET / ICC Standard 301-2019, which defines this value, in part, as the floor area of the Conditioned Space Volume within a building or Dwelling Unit, not including the floor area of attics, crawlspaces, and basements below air sealed and insulated floors. See https://codes.iccsafe.org/content/chapter/16185/ for the complete definition.</div>
        </span>
      </div><sup class='supTooltip tooltip'>?<div class="right"><h3>19.</h3> The difference between the Conditioned Floor Area (CFA) used in the design and the actual home to be certified must fall within the tolerance specified in Footnote 2, as verified by a Rater. Be advised, the Rater will calculate CFA using the definition in ANSI / RESNET / ICC Standard 301-2019, which defines this value, in part, as the floor area of the Conditioned Space Volume within a building or Dwelling Unit, not including the floor area of attics, crawlspaces, and basements below air sealed and insulated floors. See https://codes.iccsafe.org/content/chapter/16185/ for the complete definition.</div>
      </sup>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Conditioned floor area used in loads:</p>
      </div>
    </div>
    <div class="col-md-6 col-12">
    <mat-form-field appearance="fill" floatLabel="always">
      <input matInput type="number" [(ngModel)]="design.cfa" name="cfa" (blur)="validateInputs()"  [ngModelOptions]="{standalone: false}" maxlength="5" class="example-right-align" placeholder="0"
        >
      <span matSuffix>Sq. Ft.</span>
    </mat-form-field>
  </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number tooltip">
          3.6 <div class="right"><h3>20.</h3> The difference between the window area used in the design and the actual home to be certified must fall within the tolerance specified in Footnote 2, as verified by a Rater. Be advised, the Rater will calculate window area using the on-site inspection protocol provided in Normative Appendix B of ANSI / RESNET / ICC Standard 301-2019, which instructs the Rater to measure the width and height of the rough opening for the window and round to the nearest inch, and then to use these measurements to calculate window area, rounding to the nearest tenth of a square foot. See https://codes.iccsafe.org/content/chapter/16191/ for the complete protocol. </div>
        </span>
      </div><sup class='supTooltip tooltip'>?<div class="right"><h3>20.</h3> The difference between the window area used in the design and the actual home to be certified must fall within the tolerance specified in Footnote 2, as verified by a Rater. Be advised, the Rater will calculate window area using the on-site inspection protocol provided in Normative Appendix B of ANSI / RESNET / ICC Standard 301-2019, which instructs the Rater to measure the width and height of the rough opening for the window and round to the nearest inch, and then to use these measurements to calculate window area, rounding to the nearest tenth of a square foot. See https://codes.iccsafe.org/content/chapter/16191/ for the complete protocol. </div>
      </sup>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Window area used in loads:</p>
      </div>
    </div>
    <div class="col-md-6 col-12">
    <mat-form-field appearance="fill" floatLabel="always">
      <input matInput type="number" [(ngModel)]="design.wa"  name="wa" (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" class="example-right-align" placeholder="0" >
      <span matSuffix>Sq. Ft.</span>
    </mat-form-field>
  </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number tooltip">
          3.7 <div class="right"><h3>21.</h3> “Predominant” is defined as the SHGC value used in the greatest amount of window area in the home</div>
        </span>
      </div><sup class='supTooltip tooltip'>?<div class="right"><h3>21.</h3> “Predominant” is defined as the SHGC value used in the greatest amount of window area in the home</div>
      </sup>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Predominant window SHGC used in loads:</p>
      </div>
    </div>
    <div class="col-md-6 col-12">
    <mat-form-field appearance="fill" floatLabel="always">
      <input matInput type="number" [(ngModel)]="design.shgc"  name="shgc"(blur)="validateInputs()" [ngModelOptions]="{standalone: false}" class="example-right-align"
        placeholder="Predominant window SHGC used in loads:">
    </mat-form-field>
  </div>
  </div>
  <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number tooltip">
            3.8 <div class="right"> <h3>22.</h3> Infiltration rate shall reflect the value used in the confirmed or projected ERI rating for home to be certified. Alternatively, use “Average” or “Semiloose” values for the cooling season infiltration rate and “Semi-tight” or “Average” values for the heating season infiltration rate, as defined by ACCA Manual J, Eighth Edition, Version Two.</div>
          </span>
        </div><sup class='supTooltip tooltip'><div class="right"> <h3>22.</h3> Infiltration rate shall reflect the value used in the confirmed or projected ERI rating for home to be certified. Alternatively, use “Average” or “Semiloose” values for the cooling season infiltration rate and “Semi-tight” or “Average” values for the heating season infiltration rate, as defined by ACCA Manual J, Eighth Edition, Version Two.</div>
          ?</sup>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Infiltration rate used in loads:
          </p>
        </div>
      </div>
      <div class="d-flex flex-wrap row">
        <div class="d-flex col-md-6 col-12 flex-column px-3">
          <p class="design-overview-wrapper__item__detail">Summer:
          </p>
          <mat-form-field appearance="fill">
            <mat-select placeholder="Summer Infiltration Rate" [(ngModel)]="design.summerinfiltration" (ngModelChange)="validateInputs()" [ngModelOptions]="{standalone: false}" name="Summer">
              <mat-option *ngFor="let summer of summarerWinterInfiltrations" [value]="summer">
                {{summer}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="d-flex col-md-6 col-12 flex-column px-3">
          <p class="design-overview-wrapper__item__detail">Winter:
          </p>
          <mat-form-field appearance="fill">
            <mat-select placeholder="Winter Infiltration Rate" [(ngModel)]="design.winterinfiltration" (ngModelChange)="validateInputs()" [ngModelOptions]="{standalone: false}" name="Winter">
              <mat-option *ngFor="let winter of summarerWinterInfiltrations" [value]="winter">
                {{winter}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.9
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Mechanical ventilation rate used in loads:</p>
      </div>
    </div>
    <div class="col-md-6 col-12">
    <mat-form-field appearance="fill" floatLabel="always">
      <input matInput type="number" [(ngModel)]="design.mechanicalvent" name="mechanicalvent" (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" class="example-right-align"
        placeholder="Mechanical ventilation rate used in loads:">
      <span matSuffix>CFM</span>
    </mat-form-field>
  </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title" style="color:red;">* Required fields
        </p>
      </div>
    </div>
  </div>

  <div class="d-flex my-3">
    <button class="me-3" mat-flat-button color="primary"
    >Save Design</button>
    <button mat-flat-button color="warn" type="button" [routerLink]="['/design']" data-toggle="collapse"
    data-target="#dds3" aria-expanded="false" aria-controls="dds3">
    Cancel
  </button>
  </div>
</form>
</div>
